import React from 'react';
import { useTranslation } from 'react-i18next';
import Spacing from '../Spacing';
import SectionHeadingStyle3 from '../SectionHeading/SectionHeadingStyle3';
import Portfolio from '../Portfolio';
import CtaStyle2 from '../Cta/CtaStyle2';
import { pageTitle } from '../../helpers/PageTitle';

// Los datos del portfolio ahora vendrán de los archivos de traducción

export default function PortfolioPage() {
  const { t } = useTranslation();
  pageTitle(t('portfolio.pageTitle'));
  
  // Obtener los datos del portafolio desde las traducciones
  const portfolioData = t('portfolio.webDevelopment.items', { returnObjects: true }).map(item => ({
    href: '/portfolio/portfolio-details',
    imgUrl: getImageUrlForTitle(item.title),
    title: item.title,
    description: item.description,
  }));

  return (
    <>
      <Spacing lg="70" md="70" />
      <Spacing lg="140" md="80" />
      <SectionHeadingStyle3
        title={t('portfolio.webDevelopment.title')}
        subTitle={t('portfolio.webDevelopment.subtitle')}
        shape="shape_3"
      />
      <Spacing lg="75" md="60" />
      <div className="container">
        <Portfolio data={portfolioData} />
        <div className="cs_height_75 cs_height_lg_40" />
      </div>
    </>
  );
}

// Función auxiliar para asignar URLs de imágenes según los títulos
function getImageUrlForTitle(title) {
  // Esta función mapea los títulos a las URLs de imágenes correspondientes
  // Esto permite mantener las mismas imágenes incluso si los títulos cambian en las traducciones
  const imageMapping = {
    'Webs Rápidas, Seguras y Diseñadas para Vender': '/images/unalom/productoCava_2.png',
    'Tu Tienda Online, Lista para Crecer': '/images/unalom/shop_car.png',
    'Atrae Más Clientes con SEO': '/images/unalom/seoimage.jpg',
    'Landing Pages que Venden Más': '/images/unalom/lading_page.jpg',
    // Versiones en inglés
    'Fast, Secure Websites Designed to Sell': '/images/unalom/productoCava_2.png',
    'Your Online Store, Ready to Grow': '/images/unalom/shop_car.png',
    'Attract More Clients with SEO': '/images/unalom/seoimage.jpg',
    'Landing Pages that Sell More': '/images/unalom/lading_page.jpg'
  };
  
  return imageMapping[title] || '/images/unalom/productoCava_2.png'; // URL por defecto si no hay coincidencia
}
